import React from 'react';
import { AppContent } from './app-content';

import '@csstools/normalize.css/normalize.css'
import { BwjNavigationWarning } from '../framework/components/bwj-navigation-warning';

export const App: React.FunctionComponent = () => {

  return (
    <>
      <BwjNavigationWarning />
      <AppContent />
    </>
  );
};
